import { useEffect } from "react";
import ScrollReveal from 'scrollreveal';

import solomon from "../../images/solomon_about.jpg";

const About = () => {
    useEffect(()=>{

        const scroll = ScrollReveal({
            origin: "top",
            distance: "5rem",
            duration: 2000,
            reset: true
        })

        scroll.reveal(".about", {})
        scroll.reveal(".about-img",{delay: 200})
        scroll.reveal(".section-title", {delay: 100})
        scroll.reveal(".info",{ delay: 1000, interval: 500})
        scroll.reveal(".btn",{delay: 800})
    },[])

    return (
        <section id='about'>
            <div className='about container'>
                <div className='col-left'>
                    <div className='about-img'>
                        <img src={solomon} alt='solomon_pic' />
                    </div>
                </div>
                <div className='col-right'>
                    <h1 className='section-title'>
                        About <span>Me</span>
                    </h1>
                    {/* <h2>Front-End Developer</h2> */}
                    <p className="info">
                        I'm{" "}
                        <span
                            style={{
                                fontWeight: 500,
                                fontSize: "2rem",
                            }}
                        >
                            Solomon Njobvu
                        </span>
                        , A Web and Mobile App Developer based in Lusaka,
                        Zambia. Using software development to solve identified
                        problem in the community is my most enjoyable moment i
                        can ever have while am coding.
                    </p>
                    <p className="info">
                        Am open to learn and keep my options open but not too
                        open to fail to improve my current skills, to continue
                        challenging myself and to do intersting things that
                        matter.
                    </p>
                    {/* <p>
                        I love listening to music, watching tv series, making
                        friends, having a good and socail interaction with other
                        people.
                    </p> */}
                    <a href='#contact' className='btn'>
                        Hire me
                    </a>
                </div>
            </div>
        </section>
    );
};

export default About;
